var _ = require('underscore');
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="emptyTableContainer">\n  <div class="emptySQLInfo emptynessInfo">\n    <h4 class="strong">No results on this query</h4>\n    <p>Try with a different one or just <a href="#" class="clearview">clear this view</a></p>\n  </div>\n</div>\n';

}
return __p
}